import React, { useEffect } from 'react';
import {NativeWindStyleSheet} from 'nativewind';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {Provider} from 'react-redux';
import Store from './src/redux/store/store';
import AuthProvider from './src/auth/AuthProvider';
import Navigation from './src/navigation/Navigation';
import { initializeAnalytics } from './utils/Analytics/AdobeAnalyticsUtils';
import { ANALYTICS_SCRIPT } from './src/config/getEnvironmentVars';

NativeWindStyleSheet.setOutput({
  default: 'native',
});

const App = () => {
  useEffect(() => {
    // Initialize after component mounts
    initializeAnalytics(ANALYTICS_SCRIPT);
  }, []);
  return (
    <SafeAreaProvider>
      <AuthProvider>
        <Provider store={Store}>
          <Navigation />
        </Provider>
      </AuthProvider>
    </SafeAreaProvider>
  );
};

export default App;
